<template>
	<div class="datetime-box__wrap">
		<div class="datetime-box">
			<icon-calendar v-if="showIcons"></icon-calendar>
			<div class="date-box">
				<div class="date__main">
					{{ dateTime.final.date | simpleDate
					}}<span v-if="dateTime.final.date.year !== timeZoneYear">, {{ dateTime.final.date.year }}</span>
				</div>
				<div class="date__detail">
					{{ dateTime.final.date | dayOfWeek }}
					<span v-if="dateTime.final.time && daysDiff > 1"
						>&bull; {{ dateTime.final.time | formattedTime(dateTime.timeFormat) }}</span
					>
				</div>
			</div>
		</div>
		<div class="datetime-box show-to" v-if="endDate && (!dateTime.final.time || daysDiff > 1)">
			<div class="date-box">
				<div class="date__main">
					{{ endDate | simpleDate }}<span v-if="endDate.year !== timeZoneYear">, {{ endDate.year }}</span>
				</div>
				<div class="date__detail">
					{{ endDate | dayOfWeek }}
					<span v-if="endTime && daysDiff > 1">&bull; {{ endTime | formattedTime(dateTime.timeFormat) }}</span>
				</div>
			</div>
		</div>
		<div class="datetime-box" v-if="dateTime.final.time && (!endDate || daysDiff <= 1)">
			<icon-time v-if="showIcons"></icon-time>
			<div class="time-box">
				{{ dateTime.final.time | formattedTime(dateTime.timeFormat) }}
				<span v-if="endTime" class="end-time">
					&ndash; {{ endTime | formattedTime(dateTime.timeFormat) }}
					<sup v-if="daysDiff === 1">{{ endDate.plus({}).toFormat('ccc') }}</sup>
				</span>
			</div>
		</div>
	</div>
</template>

<script>
import { DateTime } from 'luxon'
import IconCalendar from '@/components/icons/IconCalendar.svg'
import IconTime from '@/components/icons/IconTime.svg'

export default {
	name: 'DateTimeBox',
	props: {
		dateTime: {
			type: Object,
			required: true,
		},
		showIcons: {
			type: Boolean,
		},
	},
	components: {
		IconCalendar,
		IconTime,
	},
	computed: {
		timeZoneYear() {
			return DateTime.fromObject({}, { zone: this.dateTime.timeZone }).year
		},
		daysDiff() {
			if (this.endDate) {
				return Math.floor(this.endDate.diff(this.dateTime.final.date, 'days').days)
			} else {
				return null
			}
		},
		endDate() {
			if (this.dateTime.duration) {
				return this.dateTime.final.date.plus(this.dateTime.duration)
			} else {
				return null
			}
		},
		endTime() {
			if (this.dateTime.final.time && this.dateTime.duration) {
				const totalMins =
					this.dateTime.duration.days * 1440 +
					(this.dateTime.final.time.hour + this.dateTime.duration.hours) * 60 +
					this.dateTime.final.time.minute +
					this.dateTime.duration.minutes
				return {
					hour: Math.floor((totalMins % 1440) / 60),
					minute: Math.floor(totalMins % 60),
				}
			} else {
				return null
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.datetime-box__wrap {
	display: flex;
}

.datetime-box {
	position: relative;
	display: flex;
	align-items: center;
	line-height: 1.25;

	.icon-svg {
		margin-right: $spacing-xs;
	}
}

.show-to {
	&::before {
		content: 'TO';
		font-size: $fs-small;
		color: transparentize(black, 0.15);
		position: absolute;
		background-color: white;
		line-height: 1;
	}
}

.date__main {
	color: theme-color(800);
	font-size: $fs-medium;
	font-weight: $fw-bold;
	line-height: 1;
}

.date__detail {
	font-size: $fs-small;
	font-weight: $fw-medium;
	line-height: 1;
	opacity: 0.8;
	margin-top: $spacing-xxxs;
}

.time-box {
	font-weight: $fw-medium;
}

.end-time {
	white-space: nowrap;
}
</style>
